import type { IconDef } from '../types';

export const healthFilled: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M13.0821 23.1121L10.0821 22.9821C8.98207 22.9321 8.12207 22.0021 8.17207 20.8921L8.41207 15.4021L2.92207 15.1621C1.81207 15.1121 0.952074 14.1821 1.00207 13.0821L1.13207 10.0821C1.18207 8.98207 2.11207 8.12207 3.22207 8.17207L8.71207 8.41207L8.95207 2.92207C9.00207 1.81207 9.94207 0.952074 11.0421 1.00207L14.0421 1.13207C15.1421 1.18207 16.0021 2.11207 15.9521 3.22207L15.7121 8.71207L21.2021 8.95207C22.3021 9.00207 23.1621 9.93207 23.1121 11.0421L22.9821 14.0421C22.9321 15.1421 22.0021 16.0021 20.8921 15.9521L15.4021 15.7121L15.1621 21.2021C15.1121 22.3021 14.1821 23.1621 13.0721 23.1121H13.0821Z',
    },
  ],
};
